import { useMemo } from "react";

import { GetCustomerProductStoreResponse } from "../../api/grpc/subscription/subscription";
import { useSubscriptionRequests } from "../../api/grpc/subscription/useSubscriptionRequests";
import useGrpcQuery from "../../lib/hooks/useGrpcQuery";

import { ProductStorePrices } from "./ProductStore.types";
import { getPriceCurrency } from "./productStorePrices";

/** The customer's Chargebee prices, in their billing currency. */
export const useProductStorePrices = (): ProductStorePrices => {
  const { getCustomerProductStore } = useSubscriptionRequests();
  const { loading, error, data } = useGrpcQuery<
    {},
    GetCustomerProductStoreResponse
  >({
    method: getCustomerProductStore,
    variables: {},
  });

  return useMemo(() => {
    const items = data?.items ?? [];

    return {
      // Until the request has returned (including the first render, before it
      // starts) prices are loading, so no card shows a hardcoded amount.
      loading: loading || (!data && !error),
      error,
      currency: getPriceCurrency(items),
      items,
    };
  }, [loading, error, data]);
};
